import { InformationCircleIcon } from "icons";
import React from "react";
import { TooltipComponent } from "ui-components/src/components/Tooltip/TooltipComponent";

import { ClientHiringPipelineResponse } from "@/hooks/api/generated";

export function AcrossQuartersCard({
  hiringData,
}: {
  hiringData: ClientHiringPipelineResponse;
}): JSX.Element {
  return (
    <div className="w-full h-full p-4 bg-[#FDF1EC] flex flex-col justify-start items-start mt-5">
      <div className="w-full flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div className="w-full md:w-auto flex flex-col justify-start items-start">
          <div className="w-full h-5 relative">
            <div className="absolute top-[-0.5px] left-0">
              <span className="text-black text-base font-semibold">
                Across {hiringData ? hiringData.quarters?.length : 0} quarters{" "}
              </span>
              <span className="text-black text-sm font-normal">
                <TooltipComponent
                  text="Not all metrics may be available for all quarters. Totals and conversion rates are calculated from available data."
                  icon={<InformationCircleIcon className="inline mt-[-10px]" />}
                />
              </span>
            </div>
          </div>
          <div className="flex flex-wrap justify-start items-center gap-2 mt-1">
            <div className="text-[#21597A] text-sm md:text-base font-medium">
              {hiringData.summary.totalApplications > 0
                ? hiringData.summary.totalApplications
                : "—"}{" "}
              applications
            </div>
            <div className="text-[#99A1AF] text-lg font-normal leading-7">
              →
            </div>
            <div className="text-[#BF4900] text-sm md:text-base font-medium">
              {hiringData.summary.totalInterviews > 0
                ? hiringData.summary.totalInterviews
                : "—"}{" "}
              interviews
            </div>
            <div className="text-[#99A1AF] text-lg font-normal leading-7">
              →
            </div>
            <div className="text-[#12811C] text-sm md:text-base font-medium">
              {hiringData.summary.totalHires > 0
                ? hiringData.summary.totalHires
                : "—"}{" "}
              hires
            </div>
          </div>
        </div>
        <div className="w-full md:w-[139.38px] h-12 flex flex-col justify-start md:items-end items-start">
          <div className="w-full h-5 relative">
            <div className="absolute left-[1.59px] top-[-0.5px] md:text-right text-black text-base font-bold">
              Overall conversion
            </div>
          </div>
          <div className="flex justify-start items-center gap-2">
            <div className="text-[#BF4900] text-sm md:text-base font-medium">
              {hiringData.summary.overallAppToIntRate > 0
                ? `${hiringData.summary.overallAppToIntRate}%`
                : "—"}
            </div>
            <div className="text-[#99A1AF] text-lg font-normal leading-7">
              →
            </div>
            <div className="text-[#12811C] text-sm md:text-base font-medium">
              {hiringData.summary.overallIntToHireRate > 0
                ? `${hiringData.summary.overallIntToHireRate}%`
                : "—"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
